module.exports = __webpack_public_path__ + "img/mongodb.49a10e35.svg";